import React from 'react';

class WelcomeBoard extends React.Component {

    constructor(props) {
      super(props)
      this.state = {
          imgLoad:false
      }
    }

    render(){
        return (
            <>
                  
            <div id="modal-inner">  
                <img
                    onLoad={() => this.setState({imgLoad: true})}
                    src={process.env.PUBLIC_URL+'/images/welcomeboard.png'} 
                    className={"welcomeImage "+((this.state.imgLoad)?"ready":"")} 
                    alt="Please click the numbered circles"
                />
            </div>{/* modal-inner */}

            </>
        );
    }
    
}

export default WelcomeBoard;